module.exports = {
    template: '#bookings-by-agents-template',
    data: function () {
        return {
            month: '',
            agent: '',
            viewMode: 'chart',
            items: [],
        };
    },
    computed: {
        bookings: {
            get: function () {
                return this.items;
            },
            set: function (bookings) {
                if (!bookings) {
                    this.items = [];

                    return;
                }

                this.items = bookings.map(function (item) {
                    return {
                        id: item.id,
                        booking_reference: item.booking_reference,
                        location:
                            item.quote && item.quote.pickup_location ? item.quote.pickup_location.name : 'Unknown',
                        start_date: moment(item.quote.start_date).format('Do of MMMM, YYYY'),
                        url: '/web/bookings/' + item.booking_reference,
                    };
                }, this);
            },
        },
    },
    methods: {
        isVisible: function (type) {
            return this.viewMode === type;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/agents/components/BookingsByAgents.js